export default [
    {
        path: '/outgoing-payment/outgoing-payment-mollie-list',
        name: 'outgoing_payment_mollie_list',
        component: () => import('@src/outgoing-payment/outgoing-payment-mollie-list.vue'),
        meta: {
            title: 'Rückzahlungen Mollie',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/outgoing-payment-paypal-list',
        name: 'outgoing_payment_paypal_list',
        component: () => import('@src/outgoing-payment/outgoing-payment-paypal-list.vue'),
        meta: {
            title: 'Rückzahlungen Paypal',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/outgoing-payment-sepa-list',
        name: 'outgoing_payment_sepa_list',
        component: () => import('@src/outgoing-payment/outgoing-payment-sepa-list.vue'),
        meta: {
            title: 'Rückzahlungen Überweisung',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/waiting-for-charge-list',
        name: 'outgoing_payment_waiting_for_charge_list',
        component: () => import('@src/outgoing-payment/outgoing-payment-waiting-for-charge-list.vue'),
        meta: {
            title: 'Auf Abbuchung wartende Rückzahlungen',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/outgoing-payment-failed-list',
        name: 'outgoing_payment_failed_list',
        component: () => import('@src/outgoing-payment/outgoing-payment-failed-list.vue'),
        meta: {
            title: 'Fehlerhafte Rückzahlungen',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/outgoing-payment-search',
        name: 'outgoing_payment_search',
        component: () => import('@src/outgoing-payment/components/outgoing-payment-search.vue'),
        meta: {
            title: 'Rückzahlungen suchen',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/edit/:id',
        name: 'outgoing_payment_edit',
        component: () => import('@src/outgoing-payment/outgoing-payment-edit.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Rückzahlung bearbeiten',
            role: 'ROLE_OUTGOING_PAYMENT',
        },
    },
    {
        path: '/outgoing-payment/settings/automatic-refund',
        name: 'outgoing_payment_settings_automatic_refund',
        component: () => import('@src/outgoing-payment/automatic-refund-settings.vue'),
        meta: {
            title: 'Automatische Rückzahlungen',
            role: 'ROLE_EDIT_OUTGOING_PAYMENT_SETTINGS',
        },
    },
    {
        path: '/outgoing-payment/settings/refund-order',
        name: 'outgoing_payment_settings_refund_order',
        component: () => import('@src/outgoing-payment/refund-payment-document-type-order.vue'),
        meta: {
            title: 'Rückzahlungsreihenfolge',
            role: 'ROLE_EDIT_OUTGOING_PAYMENT_SETTINGS',
        },
    },
    {
        path: '/outgoing-payment/settings/waiting-for-charge-automation',
        name: 'outgoing_payment_settings_waiting_for_charge_automation',
        component: () => import('@src/outgoing-payment/waiting-for-charge-automation-list.vue'),
        meta: {
            title: 'Regeln - auf Abbuchung warten',
            role: 'ROLE_EDIT_OUTGOING_PAYMENT_SETTINGS',
        },
    },
    {
        path: '/outgoing-payment/settings/waiting-for-charge-automation/create',
        name: 'outgoing_payment_settings_waiting_for_charge_automation_create',
        component: () => import('@src/outgoing-payment/waiting-for-charge-automation-create.vue'),
        meta: {
            title: 'Regeln - auf Abbuchung warten',
            role: 'ROLE_EDIT_OUTGOING_PAYMENT_SETTINGS',
        },
    },
    {
        path: '/outgoing-payment/settings/waiting-for-charge-automation/detail/:id',
        name: 'outgoing_payment_settings_waiting_for_charge_automation_detail',
        component: () => import('@src/outgoing-payment/waiting-for-charge-automation-detail.vue'),
        props(route: any) {
            return { id: Number.parseInt(route.params.id) };
        },
        meta: {
            title: 'Regeln - auf Abbuchung warten',
            role: 'ROLE_EDIT_OUTGOING_PAYMENT_SETTINGS',
        },
    },
];
